export const aboutData = {
  brandName: '蘑菇影视',
  slogan: '高清影视，畅享无限',
  foundingYear: '2020',
  introduction: '蘑菇影视创立于2020年，是国内领先的高清在线影视平台。我们致力于为全球华语用户提供最优质的观影体验，汇聚海量高清、超清、4K、蓝光画质的电影、电视剧、动漫及综艺节目。平台始终坚持"无广告、不缓冲"的核心服务理念，让每一位用户都能沉浸在纯粹的观影享受中。',
  mission: '让每一个人都能轻松享受高清影视的魅力。',
  vision: '成为全球华语用户首选的在线影视平台。',
  values: [
    { title: '用户至上', description: '一切以用户体验为核心，持续优化播放流畅度与画质表现。' },
    { title: '内容为王', description: '精选全球优质影视资源，确保每一部作品都值得观看。' },
    { title: '技术驱动', description: '采用先进的CDN加速与智能编码技术，保障流畅不缓冲的观影体验。' },
    { title: '无广告承诺', description: '绝不植入任何形式的广告，让观影回归纯粹。' }
  ],
  milestones: [
    { year: '2020', event: '蘑菇影视正式上线，主打高清电影在线观看' },
    { year: '2021', event: '用户突破100万，新增4K蓝光片源专区' },
    { year: '2022', event: '上线电视剧、动漫、综艺频道，内容全面升级' },
    { year: '2023', event: '用户突破500万，智能推荐算法全面上线' },
    { year: '2024', event: '推出HDR画质，支持杜比全景声，观影体验再升级' },
    { year: '2025', event: '全球用户突破1000万，成为华语影视平台领导者' }
  ],
  testimonials: [
    {
      name: '李明',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20corporate%20style%20photography&width=200&height=200&seq=avatar-1&orientation=squarish',
      rating: 5,
      comment: '蘑菇影视的画质真的太棒了！4K蓝光看起来就像在电影院一样，而且完全没有任何广告，体验无敌好。'
    },
    {
      name: '王芳',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2020s%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20corporate%20style%20photography&width=200&height=200&seq=avatar-2&orientation=squarish',
      rating: 5,
      comment: '追剧神器！更新速度快，画质清晰，缓冲速度超快。已经推荐给身边所有朋友了。'
    },
    {
      name: '张伟',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2040s%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20corporate%20style%20photography&width=200&height=200&seq=avatar-3&orientation=squarish',
      rating: 5,
      comment: '作为一个老影迷，蘑菇影视的片源丰富程度让我惊喜。从经典老片到最新大片，应有尽有，而且分类清晰，找片很方便。'
    },
    {
      name: '陈雪',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20elegant%20smile%2C%20clean%20white%20background%2C%20professional%20corporate%20style%20photography&width=200&height=200&seq=avatar-4&orientation=squarish',
      rating: 4,
      comment: '动漫频道做得特别好，新番更新很快，画质清晰流畅。全家人都爱用蘑菇影视看电影看剧。'
    }
  ],
  stats: [
    { label: '全球用户', value: '1000万+' },
    { label: '影视资源', value: '50000+' },
    { label: '日均播放', value: '3000万+' },
    { label: '用户好评率', value: '98.5%' }
  ],
  contact: {
    email: 'support@mogumovie.com',
    phone: '400-888-8888',
    address: '北京市朝阳区科技园区蘑菇大厦18层',
    workingHours: '周一至周日 9:00 - 21:00',
    socialMedia: {
      weibo: '蘑菇影视官方微博',
      wechat: 'mogumovie',
      douyin: '蘑菇影视'
    }
  },
  faqs: [
    {
      question: '蘑菇影视是否需要付费？',
      answer: '蘑菇影视目前完全免费，所有影视资源均可免费在线观看。我们通过技术创新来控制成本，致力于让更多人享受高品质的观影体验。'
    },
    {
      question: '蘑菇影视支持哪些设备观看？',
      answer: '蘑菇影视支持PC端网页、手机浏览器、平板等多种设备。您可以在任何支持现代浏览器的设备上流畅观看我们的影视内容。'
    },
    {
      question: '为什么蘑菇影视没有广告？',
      answer: '我们认为广告会严重影响用户的观影体验。蘑菇影视从创立之初就坚持"无广告"理念，通过技术创新和高效运营来替代广告收入模式。'
    },
    {
      question: '影片的画质有哪些选择？',
      answer: '我们提供从高清到4K HDR的多种画质选择，系统会根据您的网络状况自动推荐最佳画质。您也可以在播放器中手动切换画质。'
    },
    {
      question: '如何联系蘑菇影视的客服？',
      answer: '您可以通过发送邮件至 support@mogumovie.com 或拨打客服热线 400-888-8888 与我们联系。我们的客服团队将在第一时间为您解决问题。'
    }
  ]
};